module.exports = __webpack_public_path__ + "14-fa50a1ea-035b4c3c.webp";